module.exports = __webpack_public_path__ + "static/media/bb.e08360ac.svg";